import { JKCContact, POI } from '@/jkc/utils/type';
import { request } from '../../core';
import BaseOptions from '../base';
import { HttpStatusCode } from '@/fetch/core/constant';
import { getJKCRequestHeaders, setJKCBelongCode } from './header';

class CreateJKCTaskApi extends BaseOptions {
  private getHeaders(): Record<string, string> {
    return getJKCRequestHeaders();
  }

  public async getContactList(): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/schedule/jkc/getContactList',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const
    };
    return request(requestOptions);
  }

  public async getStationInfo(): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/schedule/jkc/getStationInfo',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const
    };
    const response = await request(requestOptions);
    if (
      response.code === HttpStatusCode.Success &&
      response.data &&
      response.data.belongCode !== undefined
    ) {
      setJKCBelongCode(response.data.belongCode);
    }
    return response;
  }

  public async getUserByPhone(params: { phone: string }): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/schedule/jkc/getUserByPhone',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const,
      body: params
    };
    return request(requestOptions);
  }

  public async addContact(params: {
    contactUserName: string;
    contactUserErp: string;
    contactUserPhone: string;
    contactUserId: string | number;
  }): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/schedule/jkc/addContact',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const,
      body: params
    };
    return request(requestOptions);
  }

  public async checkContact(params: {
    contactUserId: string | number;
  }): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/schedule/jkc/checkContact',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const,
      body: params
    };
    return request(requestOptions);
  }

  public async checkStart(params: {
    contactUserIdList: Array<string | number>;
  }): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/schedule/jkc/checkStart',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const,
      body: params
    };
    return request(requestOptions);
  }

  // 查询车辆信息
  public async getVehicleInfo(params: {
    siteLocation: {
      latitude: any;
      longitude: any; // 站点位置
    };
  }): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/jkc/provider/getJdlAvailableStore',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const,
      body: params
    };
    return request(requestOptions);
  }

  // 起点推荐
  public async recommendStartPoint(params: {
    storeId: string;
    serviceProvider?: number | string;
    location: {
      latitude: any;
      longitude: any; // 人的位置
    };
  }): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/jkc/provider/queryNearPois',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const,
      body: params
    };
    return request(requestOptions);
  }

  // 进行中的订单
  public async getInProgressOrder(params: {
    storeId: string;
    pageSize: number;
    pageNum: number;
  }): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/jkc/provider/getProcessingOrder',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const,
      body: params
    };
    return request(requestOptions);
  }

  // 地址检索
  public async addressSearch(params: {
    storeId: string;
    keyword: string;
    policy: 10 | 11; // 10起点查询,11终点查询
    location: {
      latitude: any;
      longitude: any; // 人的位置
    } | null;
    serviceProvider?: string | number;
    cityName?: string;
  }): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/jkc/provider/addressSearch',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const,
      body: {
        storeId: params.storeId,
        keyword: params.keyword,
        policy: params.policy,
        location: params.location,
        addressInfo: {
          cityName: params.cityName
        },
        pageSize: 20,
        pageNum: 1,
        ...(params.serviceProvider !== undefined
          ? { serviceProvider: params.serviceProvider }
          : {})
      }
    };
    return request(requestOptions);
  }

  // 下单接口
  public async createOrder(params: {
    storeId: string;
    startPoi: POI;
    endPoi: POI;
    dropOffPoint: { poi: POI; orderContractUsers: JKCContact[] };
    pickUpPoint: { poi: POI; orderContractUsers: JKCContact[] };
    serviceInfoDTO: {
      serviceMode: string;
      serviceType: string;
      serviceProviderProducts: {
        serviceProvider: string;
        serviceProductCode: string;
      }[];
    };
    siteLocation: {
      latitude: any;
      longitude: any;
    };
  }): Promise<any> {
    const requestOptions = {
      absoluteURL: this.fetchDomain + '/jkc/provider/submitOrder',
      method: 'POST',
      headers: this.getHeaders(),
      headerPriority: 'custom' as const,
      body: params
    };
    return request(requestOptions);
  }
}

export default new CreateJKCTaskApi();
